import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../services/settings.service';

export function useAvailablePlans() {
  return useQuery({
    queryKey: ['available-plans'],
    queryFn: () => settingsService.getAvailablePlans(),
  });
}
